import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Contact = () => {
	return (
		<StyledContact>
			<div>
				<h2 className="contact-name">Contact</h2>
			</div>
			<StyledContaInfo>
				<div>
					<div className="contact-text">
						Have a project in mind? Would you like to share it? Feel
						free to reach out by writing an e-mail.
					</div>
					<div className="getin-touch">
						<Link to={"/getintouch"}>Get in touch</Link>
						<img src="./images/underline.svg" alt="" />
					</div>
				</div>
				<div className="right-arrow">
					<a href="mailto:ekeneoshai@gmail.com?subject=Designer Inquiry">
						<img src="./images/arrow-right.svg" alt="" />
					</a>
				</div>
			</StyledContaInfo>
		</StyledContact>
	);
};

export default Contact;

const StyledContact = styled.section`
	display: grid;
	padding: 64px 16px;
	font-size: 1.2rem;
	line-height: 1.3;
	.contact-name {
		padding-bottom: 24px;
		text-align: center;
		margin: 0 auto;
	}
	@media (min-width: 750px) {
		margin: 0 auto;
		max-width: 50%;
	}
`;

const StyledContaInfo = styled.div`
	display: flex;
	justify-content: space-between;
	margin-top: 16px;
	max-width: 500px;
	margin: 0 auto;
	position: relative;
	font-size: 1rem;

	@media (min-width: 1000px) {
		width: 80%;
	}
	& > div {
		max-width: 300px;

		@media (min-width: 750px) {
			max-width: 350px;
		}
	}

	.right-arrow {
		display: flex;
		align-items: flex-end;

		@media (min-width: 750px) {
			align-self: flex-end;
		}

		@media (min-width: 1000px) {
			align-self: center;
		}

		img {
			width: 60px;
		}
	}

	.contact-text {
		max-width: 70%;
		font-size: 0.65rem;
		line-height: 1.8;
	}

	.getin-touch {
		postion: relative;
		width: max-content;
		margin-top: 16px;
		a {
			text-decoration: none;
			color: inherit;
			display: inline-block;
			font-size: 2rem;
			font-weight: 700;
		}

		img {
			width: 100%;
		}
	}
`;
